import { useFormContext } from "react-hook-form";
import { COUNTRY_LABELS } from "@shared-kernel/domain/types/supported-country";
import { RecapRow, RecapSection } from "@shared-kernel/primary/shared/onboarding/recap-section";
import { ONBOARDING_STEP } from "../form-validation/shared";
import type { ProviderOnboardingFormInputs } from "../form-validation/full-form.schema";
import { formatActivityRegistrationNumber, formatIban, formatSiret } from "@utils/formatting";

interface RecapStepProps {
  onEditStep: (stepId: number) => void;
}

export const RecapStep = ({ onEditStep }: RecapStepProps) => {
  const { getValues } = useFormContext<ProviderOnboardingFormInputs>();
  const v = getValues();
  const editForm = () => onEditStep(ONBOARDING_STEP.FORM);

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Vérifiez les informations ci-dessous avant de finaliser votre onboarding. Vous pouvez modifier chaque section si nécessaire.
      </p>
      <RecapSection title="Organisation" onEdit={editForm}>
        <RecapRow label="Nom" value={v.name} />
        <RecapRow label="Représentant légal" value={`${v.legalRepresentativeFirstName} ${v.legalRepresentativeLastName}`.trim()} />
      </RecapSection>
      <RecapSection title="Coordonnées bancaires et adresse" onEdit={editForm}>
        <RecapRow label="IBAN" value={formatIban(v.iban)} />
        <RecapRow label="Adresse postale" value={v.postalAddress.description} />
        {v.addressComplement && <RecapRow label="Complément" value={v.addressComplement} />}
        <RecapRow label="Pays" value={COUNTRY_LABELS[v.country].label} />
        <RecapRow label="SIRET" value={formatSiret(v.siret)} />
        <RecapRow label="N° de déclaration d'activité" value={formatActivityRegistrationNumber(v.activityRegistrationNumber)} />
      </RecapSection>
    </div>
  );
};
